var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.isAtTop ? 'ProductList' : 'ProductList dets_body'
  }, [_c('Header'), _c('div', {
    staticClass: "site_banner bg-cover",
    style: {
      backgroundImage: ("url(" + (_vm.basicInfo.productListBanner) + ")")
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.basicInfo.productListBanner,
      "alt": ""
    }
  }), _c('div', {
    staticClass: "wrap pro_txt a-m-c"
  }, [_c('div', {
    staticClass: "pro_ser_t fixed"
  }, [_c('a', {
    staticClass: "fnt_14 more",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.intelligentSelectionClick
    }
  }, [_c('em', [_vm._v("智能选型")]), _c('i', {
    staticClass: "icon-quandian"
  })]), _c('div', {
    staticClass: "pro_ser_t_inp"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.key,
      expression: "form.key"
    }],
    staticClass: "fnt_16",
    attrs: {
      "type": "text",
      "placeholder": "请输入产品名称、货号"
    },
    domProps: {
      "value": _vm.form.key
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchClick.apply(null, arguments);
      },
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "key", $event.target.value);
      }
    }
  }), _c('button', {
    staticClass: "fnt_20",
    on: {
      "click": _vm.searchClick
    }
  }, [_c('i', {
    staticClass: "icon-sousuo"
  })])])]), _c('div', {
    staticClass: "pro_ser_b"
  }, [_c('p', [_vm._v(" 热门搜索： "), _vm._l(_vm.hotSearchKeywords, function (item, index) {
    return _c('a', {
      key: index,
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function ($event) {
          return _vm.hotSearchKeywordsClick(item);
        }
      }
    }, [_vm._v(_vm._s(item.title))]);
  })], 2)])])]), _c('div', {
    staticClass: "product_part"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "product_type"
  }, [_c('dl', {
    staticClass: "fixed"
  }, [_c('dt', [_vm._v(" 商品分类："), _c('a', {
    class: {
      active: _vm.form.firstCategoryId === ''
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.firstCategoryClick();
      }
    }
  }, [_vm._v("全部")])]), _c('dd', _vm._l(_vm.firstCategoryList, function (item, index) {
    return _c('a', {
      key: index,
      class: {
        active: _vm.form.firstCategoryId === item.id
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function ($event) {
          return _vm.firstCategoryClick(item);
        }
      }
    }, [_vm._v(_vm._s(item.title))]);
  }), 0)]), _c('dl', {
    staticClass: "fixed"
  }, [_c('dt', [_vm._v(" 商品类别："), _c('a', {
    class: {
      active: _vm.form.secondCategoryId === ''
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.secondCategoryClick();
      }
    }
  }, [_vm._v("全部")])]), _c('dd', _vm._l(_vm.secondCategoryList, function (item, index) {
    return _c('a', {
      key: index,
      class: {
        active: _vm.form.secondCategoryId === item.id
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function ($event) {
          return _vm.secondCategoryClick(item);
        }
      }
    }, [_vm._v(_vm._s(item.title))]);
  }), 0)])]), _vm.list && _vm.list.length ? _c('div', {
    staticClass: "product_list"
  }, [_c('ul', {
    staticClass: "fixed"
  }, _vm._l(_vm.list, function (item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "wow fadeInUp"
    }, [_c('dl', {
      staticClass: "fixed"
    }, [_c('dt', {
      staticClass: "ratio-img tran_scale",
      attrs: {
        "data-ratio": "0.6139"
      }
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'product_dets',
          query: {
            id: item.id
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.productImages[0],
        "alt": item.title
      }
    })])], 1), _c('dd', [_c('router-link', {
      attrs: {
        "to": {
          name: 'product_dets',
          query: {
            id: item.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "con"
    }, [_c('h3', {
      staticClass: "fnt_20 bold"
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_vm._v(_vm._s(item.title))])]), item.modelNumber ? _c('p', [_vm._v("商品型号：" + _vm._s(item.modelNumber))]) : _c('p')])]), _c('div', {
      staticClass: "collection fixed"
    }, [_c('div', {
      class: item.inFavorites ? 'collect collected' : 'collect',
      on: {
        "click": function ($event) {
          return _vm.channelCollect(item, index);
        }
      }
    }, [!item.inFavorites ? _c('i', {
      staticClass: "icon-shoucang"
    }) : item.inFavorites ? _c('i', {
      staticClass: "icon-xz"
    }) : _vm._e(), _vm._v(" 收藏商品 ")]), _c('div', {
      staticClass: "addCar",
      on: {
        "click": function ($event) {
          return _vm.addCar(item, index, $event);
        }
      }
    }, [_c('i', {
      staticClass: "icon-3"
    }), _vm._v(" 加入购物车 ")])])], 1)])]);
  }), 0), _c('div', {
    staticClass: "pageout"
  }, [_c('el-pagination', {
    attrs: {
      "small": _vm.isMobile,
      "hide-on-single-page": _vm.value,
      "pager-count": _vm.isMobile ? 3 : 7,
      "background": "",
      "current-page": _vm.form.page,
      "page-sizes": [_vm.form.size],
      "page-size": _vm.form.size,
      "layout": " prev, pager, next, jumper",
      "total": _vm.total || 0
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]) : _c('div', [_c('el-empty', {
    attrs: {
      "image-size": 100
    }
  })], 1)])]), _c('AmendSpecification', {
    ref: "AmendSpecificationRef",
    attrs: {
      "amendSpecificationDialog": _vm.showModal,
      "data": _vm.modalData
    },
    on: {
      "amendSpecificationSubData": _vm.amendSpecificationSubData,
      "close": function ($event) {
        _vm.showModal = false;
      }
    }
  }), _c('Footer')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }